module.exports = __webpack_public_path__ + "img/star_on.9a17b41c.svg";